import { render, staticRenderFns } from "./PayPalCasesTable.vue?vue&type=template&id=75decde0&scoped=true"
import script from "./PayPalCasesTable.vue?vue&type=script&lang=js"
export * from "./PayPalCasesTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75decde0",
  null
  
)

export default component.exports